import VideoBackground from 'components/video-background'
import { NEIGHBARS_ASSETS, NEIGHBARS_VIDEOS } from '../constants'

const CampaignVideo = () => {
  return (
    <section className="neighbars__video">
      <VideoBackground
        className="neighbars__video-media"
        src={`${NEIGHBARS_ASSETS}/${NEIGHBARS_VIDEOS.campaign}`}
        desktopSrc={`${NEIGHBARS_ASSETS}/${NEIGHBARS_VIDEOS.heroDesktop}`}
        desktopMinWidth={768}
      />
    </section>
  )
}

export default CampaignVideo
